import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Users, Sprout, FileText, Briefcase, Calendar,
  Receipt, CreditCard, UserCog, Wrench, Wallet, BarChart3, Settings as SettingsIcon, LogOut,
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/clients", label: "Clients", icon: Users, testid: "nav-clients" },
  { to: "/leads", label: "Leads", icon: Sprout, testid: "nav-leads" },
  { to: "/estimates", label: "Estimates", icon: FileText, testid: "nav-estimates" },
  { to: "/jobs", label: "Jobs", icon: Briefcase, testid: "nav-jobs" },
  { to: "/calendar", label: "Calendar", icon: Calendar, testid: "nav-calendar" },
  { to: "/invoices", label: "Invoices", icon: Receipt, testid: "nav-invoices" },
  { to: "/payments", label: "Payments", icon: CreditCard, testid: "nav-payments" },
  { to: "/employees", label: "Employees", icon: UserCog, testid: "nav-employees" },
  { to: "/equipment", label: "Equipment", icon: Wrench, testid: "nav-equipment" },
  { to: "/expenses", label: "Expenses", icon: Wallet, testid: "nav-expenses" },
  { to: "/reports", label: "Reports", icon: BarChart3, testid: "nav-reports" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Sidebar({ onNavigate }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <aside className="sidebar-shell w-64 shrink-0 hidden lg:flex flex-col border-r min-h-screen" data-testid="sidebar">
      <div className="px-6 py-5 border-b border-[hsl(var(--sidebar-border))] flex items-center gap-3">
        <Logo size={44} />
        <div>
          <div className="font-display font-bold text-base leading-tight text-white">
            STAR <span className="text-primary">CAPITAL</span>
          </div>
          <div className="text-[11px] uppercase tracking-widest text-secondary font-semibold">Landscaping</div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {NAV.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testid}
            onClick={() => onNavigate && onNavigate()}
            className={({ isActive }) =>
              `sidebar-link flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium ${isActive ? "active" : ""}`
            }
          >
            <Icon className="size-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-[hsl(var(--sidebar-border))]">
        <button
          onClick={handleLogout}
          data-testid="nav-logout"
          className="sidebar-link w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium"
        >
          <LogOut className="size-4" />
          Logout
        </button>
      </div>
    </aside>
  );
}
